// extracted by mini-css-extract-plugin
export default {"specialFoot":"Footer_specialFoot__DFS43"};